export type ViewBox = {
  lngMin: number;
  latMin: number;
  lngMax: number;
  latMax: number;
};

export const getViewBox = (
  bounds?: Pick<google.maps.LatLngBounds, 'getNorthEast' | 'getSouthWest'>,
): ViewBox | undefined => {
  if (!bounds) return undefined;

  return {
    lngMax: bounds.getNorthEast().lng(),
    latMax: bounds.getNorthEast().lat(),
    lngMin: bounds.getSouthWest().lng(),
    latMin: bounds.getSouthWest().lat(),
  };
};

export const getViewBoxSearchString = (
  bounds?: Pick<google.maps.LatLngBounds, 'getNorthEast' | 'getSouthWest'>,
) => {
  const viewBox = getViewBox(bounds);
  return viewBox ? JSON.stringify(viewBox) : undefined;
};
